import React from "react";
import { Link } from "react-router-dom";
import VideoSVG from "../svg/VideoSVG";

export default function DashboardCard({ to, cardIcon, title }) {
  return (
    <Link to={to} className="dashboard-item-card">
      {cardIcon}
      <p className="text-slate-200 mt-3 ">{title}</p>
    </Link>
  );
}
